const createPropertyRecord = (key, name, value, type = 'float', readonly = false) => {
  return {
    id: key,
    value,
    name,
    type,
    readonly,
    regular: true,
  };
};

export default createPropertyRecord;
